




import Vue from 'vue'
import TermMemberContainer from '@/containers/Terms/Member'

export default Vue.extend({
  components: {
    TermMemberContainer
  },
  middleware: ['loginCheck']
})
